import template from './uploadedVehicles.html';
import controller from './uploadedVehicles.controller';

const uploadedVehiclesComponent = {
  template,
  controller,
  controllerAs: 'uploadedVehicles',
  bindings: {
    company: '=',
  },
};

export default uploadedVehiclesComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/uploadedVehicles/uploadedVehicles.component.js
 **/